// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/constants.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
/*
 * Form builder constants. Fixed numbers are NOT admin-configurable (spec §11).
 * This folder is copied to the panel and to core 16 (Phase 7): keep it
 * self-contained, no require of project modules.
 */

const BASE_FIELD_TYPES = [
    "text",
    "textarea",
    "number",
    "select",
    "multi_select",
    "checkbox",
    "radio",
    "toggle",
    "date",
    "file",
    "mobile",
    "email",
    "national_code",
    "price",
    "postal_code",
    "state",
    "city",
];

// Types whose value is chosen from `field.options`.
const OPTION_FIELD_TYPES = ["select", "multi_select", "checkbox", "radio", "toggle"];

// Option types whose value is an array of `{ title, value }`.
const MULTI_OPTION_FIELD_TYPES = ["multi_select", "checkbox"];

// Fixed typed fields: the admin only sets `required`, the validation is built in.
// Fields that may carry validation conditions (`validation_conditions`: rules on the value, e.g. the most expensive price is not
// below the cheapest one) and the text shown when one fails (`validation_message`).
const VALIDATION_FIELD_TYPES = ["number", "price"];

// The direction an admin may force on a field (`field.direction`); without it the field follows the page.
const FIELD_DIRECTIONS = ["rtl", "ltr"];

const FIXED_TYPED_FIELD_TYPES = ["mobile", "email", "national_code", "price", "postal_code", "state", "city"];

const CUSTOM_FIELD_PREFIX = "custom:";
const CUSTOM_FIELD_KEY_PATTERN = /^[a-z0-9-]+$/;
const CUSTOM_VALUE_TYPES = ["string", "number", "boolean", "array", "object"];

const KEY_PREFIX = Object.freeze({ group: "g_", field: "f_", option: "o_" });
// A group's key is made (g_ + 8 characters) and a developer may write one that says what the group is (g_step_brand): the site
// reads groups by key to draw a step of a form. Fields and options keys are always made.
const KEY_PATTERN = Object.freeze({
    group: /^g_[a-z0-9_]{1,38}$/,
    field: /^f_[a-z0-9]{8}$/,
    option: /^o_[a-z0-9]{8}$/,
});

const LIMITS = Object.freeze({
    TEXT_MAX: 500,
    TEXTAREA_MAX: 5000,
    LABEL_MAX: 300,
    OPTION_TITLE_MAX: 200,
    OPTIONS_MAX: 100,
    GROUPS_MAX: 50,
    FIELDS_MAX: 200,
    REPEAT_MAX: 10,
    VALUES_JSON_MAX_BYTES: 64 * 1024,
    EXTRA_META_MAX_KEYS: 20,
    EXTRA_META_KEY_MAX: 40,
    EXTRA_META_VALUE_MAX: 200,
    FILE_MAX_BYTES: 5 * 1024 * 1024,
    FILE_NAME_MAX: 200,
    REGEX_MAX_LENGTH: 200,
    CUSTOM_ARRAY_MAX: 100,
    CUSTOM_DEPTH_MAX: 6,
    PAGE_URL_MAX: 500,
    USER_AGENT_MAX: 500,
    DURATION_MAX_MS: 24 * 60 * 60 * 1000,
    THROTTLE_DEFAULT_COUNT: 5,
    THROTTLE_DEFAULT_WINDOW_MS: 10 * 60 * 1000,
    DEDUPE_WINDOW_MS: 24 * 60 * 60 * 1000,
    EXPORT_MAX_ROWS: 10000,
    SEARCH_TEXT_MAX: 20000,
});

// Allowed upload types: extension -> accepted mime types.
const FILE_TYPES = Object.freeze({
    jpg: ["image/jpeg"],
    jpeg: ["image/jpeg"],
    png: ["image/png"],
    webp: ["image/webp"],
    gif: ["image/gif"],
    pdf: ["application/pdf"],
    // Word 97-2003 (a resume)
    doc: ["application/msword"],
    docx: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
});

// The formats an admin may limit a file field to (`field.data.accept`); jpg stands for jpeg too. None chosen: every FILE_TYPES.
const FILE_FORMATS = Object.freeze(["jpg", "png", "webp", "gif", "pdf", "doc", "docx"]);
const FILE_FORMAT_ALIASES = Object.freeze({ jpg: ["jpg", "jpeg"] });

const GRID_SIZES = Object.freeze([3, 4, 6, 12]);
const DEFAULT_GRID = 12;
// Mobile mapping of the 12-column grid (spec §7).
const MOBILE_GRID = Object.freeze({ 3: 6, 4: 6, 6: 12, 12: 12 });

const DATE_MODES = Object.freeze(["year", "month", "day"]);
const DEFAULT_DATE_MODE = "day";

const REVIEW_STATUSES = Object.freeze(["not_set", "in_review", "reviewed", "rejected"]);
// A draft is the answer of a visitor who is still filling a form shown in steps (the form must allow it: `auto_save`); a legacy row has no status and is submitted.
const SUBMISSION_STATUSES = Object.freeze(["draft", "submitted", "deleted"]);
const DEFAULT_SUBMISSION_STATUS = "submitted";
const DRAFT_STATUS = "draft";
// the visitor gave up a draft ("cancel the request"): the row stays for the admin who wants to see it, and is nobody's answer any more
const DELETED_STATUS = "deleted";
const DEFAULT_REVIEW_STATUS = "not_set";

const DEVICE_TYPES = Object.freeze(["mobile", "tablet", "desktop"]);

// The first six come from generate-panel-form, the rest are kept so a condition
// built with that component's operator list still evaluates.
const OPERATORS = Object.freeze([
    "equals",
    "not_equals",
    "js_equals",
    "js_not_equals",
    "greater_than",
    "greater_than_or_equals",
    "less_than",
    "less_than_or_equals",
    "includes",
    "in",
    "not_includes",
    "not_in",
    "is_empty",
    "is_not_empty",
]);
// Operators that have no second side.
const UNARY_OPERATORS = Object.freeze(["is_empty", "is_not_empty"]);

export {
    BASE_FIELD_TYPES,
    OPTION_FIELD_TYPES,
    MULTI_OPTION_FIELD_TYPES,
    FIXED_TYPED_FIELD_TYPES,
    VALIDATION_FIELD_TYPES,
    FIELD_DIRECTIONS,
    CUSTOM_FIELD_PREFIX,
    CUSTOM_FIELD_KEY_PATTERN,
    CUSTOM_VALUE_TYPES,
    KEY_PREFIX,
    KEY_PATTERN,
    LIMITS,
    FILE_TYPES,
    FILE_FORMATS,
    FILE_FORMAT_ALIASES,
    GRID_SIZES,
    DEFAULT_GRID,
    MOBILE_GRID,
    DATE_MODES,
    DEFAULT_DATE_MODE,
    REVIEW_STATUSES,
    DEFAULT_REVIEW_STATUS,
    SUBMISSION_STATUSES,
    DEFAULT_SUBMISSION_STATUS,
    DRAFT_STATUS,
    DELETED_STATUS,
    DEVICE_TYPES,
    OPERATORS,
    UNARY_OPERATORS,
};
